import * as THREE from 'three';

/**
 * @classdesc
 *
 * @description
 * Base class for all Three.js scene objects.
 *
 * @constructor
 *
 */
class ThreeSceneObject {
	constructor() {
		this.addToScene = this.addToScene.bind(this);
		this.removeFromScene = this.removeFromScene.bind(this);
		this.dispose = this.dispose.bind(this);

		this.scene = null;
		this.components = [];
		this.sceneObject = null;

		// Enable Three Cache
		THREE.Cache.enabled = true;
	}

	addToScene(scene) {
		this.scene = scene;
		this.scene.add(this.sceneObject);
	}

	removeFromScene() {
		this.scene.remove(this.sceneObject);
	}

	disposeMaterials = () => {
		const sceneObjInArray =
			this.sceneObject.type === 'Group'
				? this.sceneObject.children
				: [this.sceneObject];
		sceneObjInArray.forEach((obj) => {
			if (obj.material?.length) {
				obj.material.forEach((mesh) => {
					mesh?.map?.dispose();
					mesh.map = null;
					mesh.dispose();
				});
				// obj.material=null;
			} else if (obj.material) {
				obj.material.dispose();
			}
		});
	};

	dispose() {
		this.disposeMaterials();
		if (this.scene) {
			this.components.forEach((component) => {
				if (component.dispose) component.dispose();
			});
			this.components = [];
			this.removeFromScene();
		}
	}
}

export default ThreeSceneObject;
